import { UiStage } from '@xbcb/ui-types';

export const inltBrokerIdByStageMap: { [key in UiStage]: string } = {
  [UiStage.LOCAL]: 'usCustomsBroker_5bd7b63f-ff31-4b1e-898d-a3efe4b5f582',
  [UiStage.ALPHA]: 'usCustomsBroker_066fd870-8358-4277-9e5e-f3e2f7c2a3bb',
  [UiStage.BETA]: 'usCustomsBroker_29fd7cda-f3f8-4438-9eb1-3099cea50862',
  [UiStage.GAMMA]: 'usCustomsBroker_5bd7b63f-ff31-4b1e-898d-a3efe4b5f582',
  [UiStage.PROD]: 'usCustomsBroker_04dece79-fafb-42e7-8abe-5d5321dc1f1d',
};
